module.exports = __webpack_public_path__ + "img/bigtruck.02f89e3e.png";